import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
`
